import script from "./SiderBar.vue?vue&type=script&setup=true&lang=ts"
export * from "./SiderBar.vue?vue&type=script&setup=true&lang=ts"

import "./SiderBar.vue?vue&type=style&index=0&id=7f73012e&scoped=true&lang=css"
import "./SiderBar.vue?vue&type=style&index=1&id=7f73012e&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7f73012e"]])

export default __exports__